<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import { computed } from 'vue';

import type { Permission } from '@/types/models';
import { useCurrentUser } from '@/composables/currentUser';

const { permissions, match = 'all' } = defineProps<{
    permissions: Permission['name'][];
    match?: 'all' | 'any';
}>();

const { hasPermissions } = useCurrentUser();

const isAuthorized = computed(() => hasPermissions(permissions, match));
</script>

<template>
    <slot :name="isAuthorized ? 'default' : 'unauthorized'" />
</template>
